import React, { useState } from 'react';
import MuiList from '@mui/material/List';
import styled from 'styled-components';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { Collapse, Stack } from '@mui/material';
import { Route } from './Route';

const List = styled(MuiList)<{ component?: string }>`
  position: relative;
  width: 100%;

  &.MuiList-root:not(:first-of-type) {
    padding: 8px 0 !important;
  }
`;

const Header = styled.div<{ isFirstChildRoute?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  color: ${({ theme }) => theme.text.standard};
  font-weight: 600;
  font-size: 14px;
  font-family: 'Inter';
  border-radius: 5px;
  padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(1)}`};

  margin-bottom: ${({ isFirstChildRoute }) => (!isFirstChildRoute ? 0 : '8px')};

  .MuiList-root {
    padding: 0 !important;
  }

  svg {
    font-size: 1.6ch;
  }

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.background.secondary};
  }
`;

interface Props {
  name: string;
  active: string | null;
  setActive: (val: string | null) => void;
  icon?: React.ReactNode;
  links: { name: string; href: string | null; dividor?: boolean }[];
}

export const Router: React.FC<Props> = ({ name, active, setActive, icon, links }) => {
  const [open, setOpen] = useState(true);

  return (
    <List>
      <Header onClick={() => setOpen((prevState) => !prevState)} isFirstChildRoute={!links?.[0]?.dividor}>
        <Stack direction='row' display='flex' alignItems='center' spacing={0.75}>
          {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          {icon}
          <span>{name}</span>
        </Stack>
      </Header>
      <Collapse in={open} timeout='auto' unmountOnExit>
        <List component='div' disablePadding>
          {links.map((link) => (
            <Route key={link.name} link={link} active={active} setActive={setActive} />
          ))}
        </List>
      </Collapse>
    </List>
  );
};
